import {fetchCenters} from "./centers";

export default fetchCenters;